module.exports = __webpack_public_path__ + "img/Iran_Europe.3a250202.svg";